<template>

<div class="content" :class="{'is-standalone': $route.meta.isStandalone, 'is-community': $route.meta.isCommunity, 'is-nofilter': $route.meta.nofilter}">

    <div class="content-action" v-if="actions.length">

        <template v-for="(action, index) in actions">

            <com-action :action="action" :key="index" v-if="index === 0" />

        </template>

    </div>

    <template v-if="!actions.length">

        <core-simplebar v-if="!$route.meta.isStandalone" :trackScroll="true" v-on:scroll="onContentScroll" class="content-scroll" v-bind:style="{paddingLeft: (window.is.desktop) ? window.menuPadding : null}">

            <slot></slot>

        </core-simplebar>

        <template v-if="$route.meta.isStandalone">

            <slot></slot>

        </template>

    </template>

</div>

</template>

<script>

import comAction from './content/Action'

export default {

    components: {
        'com-action': comAction
    },

    computed: {
    
        actions: function() {

            return this.$_.filter(this.$store.getters['context/actions'], function(action) {
            
                return this.$_.contains(action.routes, this.$route.name) || this.$_.contains(action.routes, '*')

            }.bind(this))
        
        }
    
    },

    methods: {

        onContentScroll: function(e) {

            this.$pubsub.$emit('content.scroll', e.y)

        }

    }

}

</script>

<style scoped>

.content {
	height: calc(100vh - var(--vh-offset, 0px));
    background-color: #fff;
	transition: left 100ms linear;
}

.is-mobile .content {
    background-color: #fff;
	transition: none;
}

.content.is-standalone {
    background-color: #082534;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content-scroll {
    overflow-y: auto;
    overflow-x: hidden;
	height: calc(100vh - var(--vh-offset, 0px));
    padding: 84px 40px 40px 424px;
}

.content.is-nofilter .content-scroll {
    padding: 40px 40px 40px 424px;
}

.content.is-community .content-scroll {
    padding: 64px 40px 40px 40px;
}

.is-smaller .content-scroll {
    padding: 148px 20px 20px 20px;
}

.is-smaller .content.is-community .content-scroll {
    padding: 148px 20px 20px 20px;
}

.is-mobile .content-scroll {
    padding: 50px 10px 10px 10px;
}

.is-mobile .content.is-nofilter .content-scroll,
.is-mobile .content.is-community .content-scroll {
    padding: 50px 10px 10px 10px;
}

.content-action {
    overflow-y: auto;
    overflow-x: hidden;
	height: calc(100vh - var(--vh-offset, 0px));
    padding: 104px 40px 40px 360px;
    background-color: #fff;
}

.is-smaller .content-action {
    padding: 84px 20px 20px 20px;
}

.is-mobile .content-action {
    padding: 96px 0px 0px 0px;
}

</style>
